import type { IpcMessage } from '@flowus/shared';
import type { IpcRendererEvent } from 'electron';
import { getIpcRenderer, isFlowUsApp } from '@flowus/common/flowus-utils/check-is-desktop-app';

export { getIpcRenderer, isFlowUsApp };

export const ipcInvoke = (key: IpcMessage | string, ...args: any[]): Promise<any> => {
  return new Promise((resolve) => {
    const flowusIpc = getIpcRenderer();
    void flowusIpc?.invoke(key as any, ...args).then(resolve);
  });
};

export const ipcOnMessage = (
  key: IpcMessage | string,
  callback: (e: IpcRendererEvent, ...args: any[]) => void
) => {
  const flowusIpc = getIpcRenderer();
  try {
    flowusIpc?.on(key as any, callback);
  } catch (error) {
    console.error(error);
  }
};

export const ipcSendMessage = (key: IpcMessage | string, ...args: any[]) => {
  const flowusIpc = getIpcRenderer();
  try {
    flowusIpc?.send(key as any, ...args);
  } catch (error) {
    console.error(error);
  }
};
